import { Controller } from '@hotwired/stimulus';
import Splide from '@splidejs/splide';

export default class extends Controller {
    connect() {

        const context = this;
        const element = context.element;
        const additionalConfig = element.dataset.splide ? JSON.parse(element.dataset.splide) : {}

        // Config https://splidejs.com/guides/options/
        const config = {
            lazyLoad: 'nearby',
            autoWidth: true,
            focus: 'left',
            type: 'loop',
            speed: 1000,
            autoplay: true,
            ...additionalConfig,
        };

        this.splide = new Splide(this.element, config);
        this.splide.mount();
    }
}
